module.exports = __webpack_public_path__ + "img/prime-burguer.4fa7117c.png";